import * as React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

import * as DetailsUtils from "./details-utils";
import "./post.css";
import { LazyLoadImageCDN } from "../Card/CDNImage";

export const Post = (props: any) => {
    const { t, i18n } = useTranslation();

    //console.log("data", props.item_data)

    //const created_date = new Date().toDateString();
    //const modified_date = new Date().toDateString();

    //const [hideExplanation, setHideExplanation] = React.useState(false);

    //let currentLayout = "explanation";
    //let currentLayout = "embeded";
    //let currentLayout = "hover";

    return (
        <>
            <div id="main-container" className="container-fluid">
                <div className="row" style={{ backgroundColor: "#eff1f3" }}>
                    <div className="col col-lg-6 offset-lg-3 col-md-12 col-12">
                        <div id="post-header-horizontal-container">
                            <LazyLoadImageCDN 
                                cdnPath={DetailsUtils.img_cdn}
                                localPath={DetailsUtils.img}
                                alt={props.item_data["N"]}
                                libAssetsPath={window.Paths.POST_LIB_ASSETS}
                                id={"post-logo"}
                                max_width={"100%"}
                                height={"auto"}
                            />

                            <div id="post-header-vertical-container">
                                <h1>{props.item_data["N"]}</h1>

                                <div id="post-header-desc">
                                    <div>{props.item_data["D"][0]}</div>
                                </div>

                                {/* Until we have a way to prevent free/without maintenance users to update posts, remove downloads*/}
                                {/* <div>
                                    <button
                                        id="post-download-btn"
                                    >
                                        {t('library-overlays.cardDownloadBtn')})}
                                    </button>
                                    <button
                                        id="post-install-btn"
                                    >
                                        {t('library-overlays.cardInstallBtn')})}
                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center" id="post-details-content" style={{ marginTop: "1.5rem" }}>
                    <div className="col col-12 col-lg-6 col-md-12 col-12">

                        {props.item_data.hasOwnProperty("D") && props.item_data["D"].length > 1 && (
                            <>
                                <h2>{t('details.desc')}</h2>
                                {props.item_data["D"].map((desc) => {
                                    let reg = /([a-zA-Z0-9\s\.]+)(\*\*([a-zA-Z0-9_]+)\*\*)([a-zA-Z0-9\s\.]+)/;
                                    let match = desc.match(reg);

                                    if (match == null) {
                                        return (
                                            <p>{desc}</p>
                                        );
                                    }

                                    if (match != null) {
                                        let [
                                            whole_str,
                                            first,
                                            bold_with_asterisks,
                                            bold,
                                            second
                                        ] = match;

                                        return (
                                            <p>
                                                {first}
                                                <b>{bold}</b>
                                                {second}
                                            </p>
                                        )
                                    }
                                })}
                            </>
                        )}

                        {props.item_data.hasOwnProperty("VARS") && (
                            <div className="table-responsive">
                                <h2>{t('details.settings')}</h2>
                                <p>{t('details.pcustomize').replace(/\{name\}/g,props.item_data["N"])}</p>
                                <table className="table post-variable-table">
                                    <thead>
                                        <tr>
                                            <td><strong>{t('details.variables')}</strong></td>
                                            <td><strong>{t('details.value')}</strong></td>
                                            <td><strong>{t('details.desc')}</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(props.item_data["VARS"]).map((key) => {
                                            const value = props.item_data["VARS"][key]["value"];
                                            const comment = props.item_data["VARS"][key]["comment"];

                                            return (
                                                <>
                                                    <tr>
                                                        <td data-label={t('details.variables')} style={{ wordWrap: "break-word", maxWidth: "150px" }}>{key}</td>
                                                        <td data-label={t('details.value')} style={{ wordWrap: "break-word", maxWidth: "100px" }}>{value}</td>
                                                        <td data-label={t('details.desc')} style={{ wordWrap: "break-word", maxWidth: "240px" }}>{comment.map(s=>{
                                                            return (
                                                                <>
                                                                    {s}<br />
                                                                </>
                                                            );
                                                        })}</td>
                                                    </tr>
                                                </>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <div id="extra-info" className="col col-12 col-lg-2 col-12">
                        {props.item_data.hasOwnProperty("B") && props.item_data["B"].length > 0 && (
                            <div className="post-info-block left-border">
                                <h5>{t('filters-posts.brand')}</h5>
                                <div className="post-info-btn-container">
                                    <button
                                        className="post-info-btn"
                                        onClick={(e) => {
                                            if (window.Settings.LOCAL_BUILD)
                                                window.open("http://localhost:3005/#filter?brand=" + props.item_data["B"])
                                            else
                                                window.open(DetailsUtils.home_lang() + "posts#filter?brand=" + props.item_data["B"])
                                        }}
                                    >
                                        {props.item_data["B"]}
                                    </button>
                                </div>
                            </div>
                        )}

                        {props.item_data.hasOwnProperty("SC") && props.item_data["SC"].length > 0 && (
                            <div className="post-controller-block left-border">
                                <h5>{t('filters-posts.controller')}</h5>
                                <div className="post-controller-btn-container">
                                    {props.item_data["SC"].map(controller => (
                                        <button
                                            className="post-controller-btn"
                                            onClick={(e) => {
                                                if (window.Settings.LOCAL_BUILD)
                                                    window.open("http://localhost:3005/#filter?controller=" + controller.replace(" ", "-"))
                                                else
                                                    window.open(DetailsUtils.home_lang() + "posts#filter?controller=" + controller.replace(" ", "-"))
                                            }}
                                        >
                                            {controller}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        {props.item_data.hasOwnProperty("EXT") && props.item_data["EXT"] != "" && (
                            <div className="post-controller-block left-border">
                                <h5>{t('filters-posts.extension')}</h5>
                                <div className="post-controller-btn-container">
                                    <button
                                        className="post-controller-btn"
                                        onClick={(e) => {
                                            if (window.Settings.LOCAL_BUILD)
                                                window.open("http://localhost:3005/#filter?extension=" + props.item_data["EXT"])
                                            else
                                                window.open(DetailsUtils.home_lang() + "posts#filter?extension=" + props.item_data["EXT"])
                                        }}
                                    >
                                        {props.item_data["EXT"]}
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="post-links-block left-border">
                            <h5>{t('details.links')}</h5>
                            <div className="post-link">
                                <a href={"/doc/" + window.Languages.language + "/Post-Processors.html"} target="_blank">{t('details.doc')}</a>
                                <a href="https://robodk.com/doc/en/PythonAPI/postprocessor.html" target="_blank">{t('details.API')}</a>
                                <a href={DetailsUtils.home_lang() + "posts"} target="_blank">{t('details.pplib')}</a>
                                {/* <a>Github</a> */}
                            </div>
                        </div>
                        {/* 
                        <div className="post-more-info-block left-border">
                            <h5>More Info</h5>
                            <table>
                                <tbody className="post-more-info-table">
                                    <tr>
                                        <td>Version</td>
                                        <td>1.0.0</td>
                                    </tr>
                                    <tr>
                                        <td>Created on</td>
                                        <td>{created_date}</td>
                                    </tr>
                                    <tr>
                                        <td>Modified on</td>
                                        <td>{modified_date}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
};
